import { useCreditAppsData } from './useCreditAppsData';
import { CreditApplicationsDataTable } from './CreditApplicationsDataTable';

const CreditApplicationsDataReports = () => {
  const { rows, isLoading } = useCreditAppsData();

  return (
    <div className="flex flex-col w-full h-full pt-4">
      <CreditApplicationsDataTable data={rows} isLoading={isLoading} />
    </div>
  );
};

export default CreditApplicationsDataReports;
